export enum Role {
  HOUSEKEEPER = "housekeeper",
  OWNER = "owner",
  WORKER = "worker",
  GUEST = "guest",
}
